import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { catchError, concatMap, first, map, switchMap } from 'rxjs/operators';

import { PUSHNOTIFCATIONS_ENDPOINTS } from '../../shared/models/Constants';
import { SharedServiceService } from '../../shared/services/shared-service.service';
import { UtilitiesService } from '../../shared/services/utilities/utilities.service';
import {
    errorNotifications,
    errorReadNotification,
    getNotifications,
    readNotification,
    successNotifications,
    successReadNotification,
} from '../actions';
import { HandleErrorService } from './../../shared/interceptors/handle-error.service';
import { IRespNotifications } from './../../shared/models/NotificacionTendero';

@Injectable()
export class NotificationsEffets {
    constructor(
        private actions$: Actions
        , private handleErrorS: HandleErrorService
        , private translate: TranslateService
        , private httpS: SharedServiceService
        , private utilS: UtilitiesService
    ) { }

    /**
     * Obtiene las notificaciones del usuario
     */
    public getNotifications$ = createEffect(
        () => this.actions$.pipe(
            ofType(getNotifications),
            concatMap(actions => this.handleErrorS.getToken$().pipe(map(jwt => {
                const decodeToken = this.utilS.getDecodeTokenJwt(jwt);
                const idUser = decodeToken.ID_Tendero;
                return { ...actions, idUser };
            }))),
            concatMap(actions => this.translate.get('Miscellaneous.PushParams').pipe(first(), map(obj => ({ ...actions, ...obj })))),
            switchMap(
                (actions) => this.httpS.executeRequestByUser(PUSHNOTIFCATIONS_ENDPOINTS.get_notifications, actions)
                    .pipe(
                        map((resp: IRespNotifications) => ({ ...resp, data: resp.data ?? { totalNotifications: 0, notifications: [] } })),
                        map(resp => successNotifications(resp)),
                        catchError((err: Error) => of(errorNotifications({ payload: err })))
                    )
            )
        )
    );

    /**
     * Actualiza Leido de la notificacion del usuario
     */
    public readNotification$ = createEffect(
        () => this.actions$.pipe(
            ofType(readNotification),
            switchMap(
                (actions) => this.httpS.executeRequestByUser(PUSHNOTIFCATIONS_ENDPOINTS.patch_notifications_view, actions)
                    .pipe(
                        map(resp => successReadNotification(resp)),
                        catchError((err: Error) => of(errorReadNotification({ payload: err })))
                    )
            )
        )
    );
}